/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from "react";
import Select from "react-select";
import { DFPAPIEndpointGalley } from "../../../utils/axios";
import "../../../assets/styles//styles.scss";
import { useTranslation } from "react-i18next";
import downloadMasterIcon from "../../../assets/icons/download-master.svg";
import plus from "../../../images/icons/plus.png";
import minus from "../../../images/icons/minus.png";
import trolley from "../../../assets/images/wheels.png";
import { saveAs } from "file-saver";
import useToastAssist from '../../../utils/useToastAssist';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import usePermissions from "../../../utils/userPermissions";
import {customSelSearch} from '../../../utils/configs.js';
import CustomSelect from "../../../common/CustomSelect";
import {ThemeContext} from '../../../contexts/themeContext';
import { toSlotPickerOptions, resolveSlotItemLabel, formatSlotOptionLabel } from './trolleySlotHelpers';
 
export const TrolleyLoading = ({
  aircraftId: initialAircraftId,
  trolleyId,
  trolleyType,
  galleyId,
  selectedAircraft,
  onClose,
  hideGalleyNav = false,
}) => {

 
  const row28 = {row1: 0,row2: 0,row3: 0,row4: 0,row5: 0,row6: 0,row7: 0,row8: 0,row9: 0,row10: 0,row11: 0,row12: 0,row13: 0,row14: 0,row15: 0,row16: 0,row17: 0,row18: 0,row19: 0,row20: 0,row21: 0,row22: 0,row23: 0,row24: 0,row25: 0,row26: 0,row27: 0,row28: 0};

  const row12 = {
    row1: 0,
  };

  const DEFAULT_SECTOR_FACTORS = { s2: 1.8, s3: 1, multi: 1 };

  const { ready } = useTranslation();
  const galleyIndex = null;
  const savedGalley = { stat: false, galleyIndex };
  const [showGalley, setShowGalley] = useState(false);
  const [enumerateItems, setEnumerateItems] = useState([]);
  const [mealCategories, setMealCategories] = useState([]);
  const [loading, setIsloading] = useState(false);
  const [staticCountSmu] = useState(1);
  const [status, setStatus] = useState({});
  const [toggleState, setToggleState] = useState(null);
  const [savedTab, setSavedTab] = useState([]);
  const [aircraftOptions, setAircraftOptions] = useState({ model: [] });
  const [galleyDetails, setGalleyDetails] = useState([]);
  const [galleyTabs, setGalleyTabs] = useState([{}]);
  const [aircraftId, setAircraftId] = useState([{}]);
  const [galleyArr, setGalleyArr] = useState([]);
  const {themedColor} = useContext(ThemeContext);
  const [rackLoadingSelHalf, setRackLoadingSelHalf] = useState([]);
  const [rackLoadingSelFull, setRackLoadingSelFull] = useState([]);
  const [clickTrolley, setClickTrolley] = useState("smu");
  const [fullCartSide, setFullCartSide] = useState("back");
    const {toastError,toastSuccess} = useToastAssist();

  const [airCraftLoadingSel, setAircraftLoadingSel] = useState({
    model: "",
    galley: "",
    businessClass: false,
    economy: false,
    premEconomy: false,
  });
  const [cartsStatus, setCartsStatus] = useState({

    fullCart: 0,
    halfCart: 0,
    smu: 0,
    stowage: 0,
  });
 

  const { hasPermission: createTrolleyPlan } = usePermissions('create', "configuration.lcc.trolley-loading-plan");
  const { hasPermission: editTrolleyPlan } = usePermissions('edit', "configuration.lcc.trolley-loading-plan");
  const { hasPermission: deleteTrolleyPlan } = usePermissions('delete', "configuration.lcc.trolley-loading-plan");
  const { hasPermission: viewDetailsTrolleyPlan } = usePermissions('view', "configuration.lcc.trolley-loading-plan");

  const [halfRowDetails, setHalfRowDetails] = useState({ half1: row28 });
  const [fullRowDetails, setFullRowDetails] = useState({ full1: row28 });
  const [fullRowDetailsFront, setFullRowDetailsFront] = useState({
    fullfront1: row28,
  });
  const [smuRowDetails, setSmuRowDetails] = useState({ smu1: row12 });
  const [halfDetails, setHalfDetails] = useState({});
  const [fullDetails, setFullDetails] = useState({});
  const [smuDetails, setSmuDetails] = useState({});
  const [, setStowageDetails] = useState({});
  const [indexValue, setIndexValue] = useState({});
  const [sectorFactorsByAircraft, setSectorFactorsByAircraft] = useState({});

  const getSectorFactors = () => sectorFactorsByAircraft[aircraftId] || DEFAULT_SECTOR_FACTORS;

  const updateSectorFactor = (key, value) => {
    setSectorFactorsByAircraft((prev) => ({
      ...prev,
      [aircraftId]: {
        ...(prev[aircraftId] || DEFAULT_SECTOR_FACTORS),
        [key]: value === '' ? '' : Number(value),
      },
    }));
  };


  const getSectorInputId = (prefix, type, index, subIndex, code, side) =>
    `${prefix}-${type}-${index}-${subIndex}-${code}-${side}`;

  const computeSectorValue = (baseValue, factor) => {
    const base = Number(baseValue);
    const f = Number(factor);
    if (!base || !f) return '';
    return Math.round(base * f);
  };

  const onBaseQuantityChange = (e, type, index, subIndex, code, side) => {
    const baseValue = e.target.value;
    const factors = getSectorFactors();
    const s2Ele = document.getElementById(getSectorInputId('sectorS2', type, index, subIndex, code, side));
    const s3Ele = document.getElementById(getSectorInputId('sectorS3', type, index, subIndex, code, side));
    const multiEle = document.getElementById(getSectorInputId('sectorMulti', type, index, subIndex, code, side));
    if (s2Ele) s2Ele.value = computeSectorValue(baseValue, factors.s2);
    if (s3Ele) s3Ele.value = computeSectorValue(baseValue, factors.s3);
    if (multiEle) multiEle.value = computeSectorValue(baseValue, factors.multi);
  };

 

  useEffect(() => {
    getItemsEnumerate();

    // When opened from the trolley listing (hideGalleyNav=true), always fetch
    // fresh aircraft data so previously saved slot items are shown immediately.
    if (hideGalleyNav) {
      const id = initialAircraftId
        || selectedAircraft?.data?.id
        || selectedAircraft?.value;
      if (id) {
        DFPAPIEndpointGalley.get(`/galley/aircraftTypes/${id}`)
          .then((res) => {
            if (res?.data?.galleys) {
              setGalleyArr(res.data.galleys);
              setAircraftId(id);
            }
          })
          .catch(() => {/* fall through to prop-supplied selectedAircraft */});
      }
    }
  // eslint-disable-next-line no-use-before-define
  }, [])

  useEffect(() => {
    if (aircraftOptions?.galleyNames) {
      setToggleState(aircraftOptions.galleyNames[1]["value"]);
    }
  }, [aircraftOptions?.galleyNames]);

  useEffect(() => {
    if (galleyDetails) {
      const actModel = galleyDetails.reduce(
        (acc, item, index) => [
          ...acc,
          { key: index + 1, label: `${item.key}`, value: `${item.key}` },
        ],
        [{ key: 0, label: "Select Aircraft", value: "" }]
      );

      if (actModel.length) {
        setAircraftOptions({ model: actModel });
      }
    }
  }, [galleyDetails]);
useEffect(() => {
 
  if (trolleyId && trolleyType && galleyArr && galleyArr.length > 0) {
 
    try {
 
      let matchedGalley = null;
      let matchedAllot = null;
      
      for (const galley of galleyArr) {
        for (const bayArea of (galley.bayAreas || [])) {
          for (const trolley of (bayArea.trolleys || [])) {
            for (const allot of (trolley.cartQuantityAllots || [])) {
              if (allot._id === trolleyId) {
                matchedGalley = galley;
                matchedAllot = allot;
               
                break;
              }
            }
            if (matchedGalley) break;
          }
          if (matchedGalley) break;
        }
        if (matchedGalley) break;
      }
      
      if (matchedGalley && matchedAllot) {
     
        setToggleState(matchedGalley.name);
      } else {
        
        if (galleyArr.length > 0) {
 
          setToggleState(galleyArr[0].name);
        }
      }
    } catch (error) {
     
    }
  }
}, [trolleyId, trolleyType, galleyArr, selectedAircraft])
 
useEffect(() => {
  if (toggleState && galleyArr && galleyArr.length > 0) {
 
    const matchedGalley = galleyArr.find(g => g.name === toggleState);
    if (matchedGalley && (!indexValue || indexValue._id !== matchedGalley._id)) {
     
      galleyFilter(matchedGalley);
    }
  }
}, [toggleState, galleyArr])

 
useEffect(() => {

  
  if (selectedAircraft?.data) {
    const actModel = [{
      key: 1,
      label: selectedAircraft.data.key || selectedAircraft.data.code || 'Aircraft',
      value: selectedAircraft.data.key || selectedAircraft.data.code || selectedAircraft.data.id
    }];

    setAircraftOptions({ model: actModel });
    
    setAircraftLoadingSel({
      model: actModel[0].label,
      galley: actModel[0].label,
      businessClass: false,
      economy: false,
      premEconomy: false
    });
    
    if (selectedAircraft?.data?.galleys && Array.isArray(selectedAircraft.data.galleys)) {

      setGalleyArr(selectedAircraft.data.galleys);
      setAircraftId(selectedAircraft.data.id);
    }
  } else {

  }
}, [selectedAircraft]);



useEffect(() => {
  if (galleyArr && galleyArr.length > 0) {
 
    if (trolleyType && galleyId) {
      try {
        const matchedGalley = galleyArr.find(g => g._id === galleyId);
        
        if (matchedGalley) {
         
          setToggleState(matchedGalley.name);

          const trolleyTypeMap = {
            'Full Cart': 'full',
            'Half Cart': 'half',
            'SMU': 'smu',
            'Misc. Stowage': 'stowage'
          };
          
          const systemType = trolleyTypeMap[trolleyType] || 'smu';
          setClickTrolley(systemType);
          setFullCartSide('back');
 
          galleyFilter(matchedGalley);
           setShowGalley(true);
           
        }
      } catch (error) {
       
      }
    }
  }
}, [galleyArr, trolleyType, galleyId]) 

useEffect(() => {
  if(status && (status.success||status.error)){
  status.error ? toastError(status.error) : toastSuccess(status.success);
    setTimeout(() => {
      setStatus({});
    }, 5000);
  }
}, [status])




  const getItemsEnumerate = async () => {
    try {
      const [itemsRes, configsRes] = await Promise.all([
        DFPAPIEndpointGalley.get('api/items/enumerate'),
        DFPAPIEndpointGalley.get('galley/mealMenuPlan/configs').catch(() => null),
      ]);
      let items = itemsRes.items;
      items.unshift({_id: null, itemId: null, itemName: "Select Item", unit: null, itemCode:null});
      if (itemsRes) {
        setEnumerateItems(items);
      }
      if (configsRes && configsRes.data && configsRes.data.mealCategory && configsRes.data.mealCategory.list) {
        setMealCategories(configsRes.data.mealCategory.list.map((c) => ({ id: c.id, label: c.label })));
      }
    } catch (error) {

    }

  };


  const getGalleyTabs = () => {
    const res = galleyArr.map((gl, index) => {
      let color = "white";
      savedTab.filter((c) => {
        if (c.name === gl.name) {
          c.value ? (color = "#06d406") : (color = "white");
        }
        return true;
      });
      galleyArr[index]["color"] = color;
      return (
        <React.Fragment key={index}>
          <button
            style={{ width: "180px", marginTop: "1.4rem" }}
            className={
              toggleState === gl.name && !savedGalley.galleyIndex
                ? `tabs active-tabs ${gl.color === '#06d406' ? 'active-tabs-save' : ''}`
                : toggleState === gl.name && gl.color !== '#06d406'
                ? "tabs active-tabs-save"
                : "tabs"
            }
            onClick={() => toggleTab(gl)}
          >
            <span
              className="dropdownStyle1-TextMedium"
              style={{ color: gl.color }}
            >
              {gl.name}
            </span>
          </button>
          <br />
        </React.Fragment>
      );
    });
    return res;
  };

  const onAircraftChange = (e) => {
    setAircraftLoadingSel((prev) => {
      return { ...prev, model: e?.value };
    });
    const galleySelected = galleyDetails.find(
      (gl) => gl.key === e?.value
    );
    if (galleySelected) {
      setGalleyArr(galleySelected.galleys);
      toggleTab(galleySelected.galleys[0]);
      setAircraftId(galleySelected.id);
    }
  };

  const onRackChange = (e) => {
    let stateType = e.target.name === 'racksFull' ? rackLoadingSelFull : rackLoadingSelHalf;
    let rackId = e.target.id;
    let rackVal = e.target.value;
    const member = stateType.map((ele) => (
      ele.val[0] === rackId ? { val: [ele.val[0], rackVal] } : ele
    ));
    const hasMatch = member.some((ele) => ele.val[0] === rackId);
    const next = hasMatch ? member : [...member, { val: [rackId, rackVal] }];

    e.target.name === 'racksFull' ? setRackLoadingSelFull(next) : setRackLoadingSelHalf(next);
    galleyFilter(indexValue,"rack");
  };

  const toggleTab = (index) => {
    setToggleState(index?.name);
    setGalleyTabs(index);
    galleyFilter(index);
    setShowGalley(true);
  };

  const galleyFilter = (index,type) => {
    setIndexValue(index);
    let fullMerge = [];
    let halfMerge = [];
    let smuMerge = [];
    let stowageMerge = [];
 
    const allTrolleys = [];
    (index?.bayAreas || []).forEach((bayArea) => {
      (bayArea.trolleys || []).forEach((trolley) => {
        allTrolleys.push({
          ...trolley,
          bayAreaName: bayArea.name,
          bayAreaId: bayArea._id,
        });
      });
    });
 
    allTrolleys.forEach((element) => {
      const trolleyType = element.id; // "smu", "full", "half", "stowage"
      
      if (element.cartQuantityAllots && element.cartQuantityAllots.length > 0) {
 
        element.cartQuantityAllots.forEach((allot) => {
          if (trolleyType === "full") {
            fullMerge.push({ id: element._id, code: element.code, data: allot, bayArea: element.bayAreaName, bayAreaId: element.bayAreaId });
          } else if (trolleyType === "half") {
            halfMerge.push({ id: element._id, code: element.code, data: allot, bayArea: element.bayAreaName, bayAreaId: element.bayAreaId });
          } else if (trolleyType === "smu") {
            smuMerge.push({ id: element._id, code: element.code, data: allot, bayArea: element.bayAreaName, bayAreaId: element.bayAreaId });
          }
        });
      } else if (trolleyType === "stowage") {
        for (let i = 0; i < (element.quantity || 1); i++) {
          stowageMerge.push({
            id: element._id,
            code: element.code,
            data: { _id: element._id, items: { leftColumn: [], rightColumn: [] } },
            bayArea: element.bayAreaName,
            bayAreaId: element.bayAreaId,
          });
        }
      } else if (element.cartQuantityAllots) {
        for (let i = 0; i < (element.quantity || 1); i++) {
          const fallbackData = { _id: element._id, items: { leftColumn: [], rightColumn: [] } };
          if (trolleyType === "full") {
            fullMerge.push({ id: element._id, code: element.code, data: fallbackData, bayArea: element.bayAreaName, bayAreaId: element.bayAreaId });
          } else if (trolleyType === "half") {
            halfMerge.push({ id: element._id, code: element.code, data: fallbackData, bayArea: element.bayAreaName, bayAreaId: element.bayAreaId });
          } else if (trolleyType === "smu") {
            smuMerge.push({ id: element._id, code: element.code, data: fallbackData, bayArea: element.bayAreaName, bayAreaId: element.bayAreaId });
          }
        }
      }
    });
    
    setFullDetails(fullMerge);
    setHalfDetails(halfMerge);
    setSmuDetails(smuMerge);
    setStowageDetails(stowageMerge);

    getGalleyCount(smuMerge, halfMerge, fullMerge, stowageMerge, type);
    stateLoop(smuMerge, halfMerge, fullMerge, stowageMerge);
  };
  const getGalleyCount = (smu, half, full, stowage, type) => {
    let smuCnt = smu.length;
    let halfCnt = half.length;
    let fullCnt = full.length;
    let stowageCnt = 0;
    setCartsStatus({
      fullCart: fullCnt,
      halfCart: halfCnt,
      smu: smuCnt,
      stowage: stowageCnt,
    });
    if(type === undefined){
      let member = [];
      if(member.length === 0){
        let id = 0;
        let type = "";
        half.map((item,ind) => {
          id = item.data._id;
          type = item.data.items.leftColumn[0] === undefined ? "drawer" : (item.data.items.leftColumn[0]?.rackType || 'drawer');
          member.push({val : [id,type]});
          setRackLoadingSelHalf(member)
          return null
      })
        full.map((item,ind) => {
          id = item.data._id;
          type = item.data.items.leftColumn[0] === undefined ? "drawer" : (item.data.items.leftColumn[0]?.rackType || 'drawer');
          member.push({val : [id,type]});
          setRackLoadingSelFull(member)
          return null
        })
      }
    }
  };

  const onChangeHandler = (value, type, index, subIndex, code, side) => {
    const ele = document.getElementById(
      "select-" + type + "-" + index + "-" + subIndex + "-" + code + "-" + side
    );
    ele.setAttribute("attrValue", value.value);
    ele.setAttribute("attrName", value.label);
  };

  const refreshTrolleyData = async () => {
    const res = await DFPAPIEndpointGalley.get(
      "/galley/aircraftTypes/" + aircraftId
    );
    if (res) {
      setGalleyArr(res.data.galleys);

      // Determine which galley to re-filter: prefer the tab-selected one,
      // fall back to the galleyId prop (used when hideGalleyNav=true).
      const targetName = galleyTabs?.name;
      const targetId   = galleyTabs?._id || galleyId;

      const updatedGalley = targetName
        ? res.data.galleys.find(g => g.name === targetName)
        : res.data.galleys.find(g => g._id === targetId);

      if (updatedGalley) {
        galleyFilter(updatedGalley);
      }
    }
  };


  const saveTrolleyPlan = async () => {
    // Build a map: trolleyId -> { bayAreaId, allots: { [allotId]: allotObj } }
    const trolleyPayloadMap = {};
    [...smuDetails, ...halfDetails, ...fullDetails].forEach((detail) => {
      if (!trolleyPayloadMap[detail.id]) {
        trolleyPayloadMap[detail.id] = { bayAreaId: detail.bayAreaId, allots: {} };
      }
      // Spread existing allot data to preserve _id, code, weight, etc.
      // Reset items — DOM values are the source of truth for this save.
      trolleyPayloadMap[detail.id].allots[detail.data._id] = {
        ...detail.data,
        items: { leftColumn: [], rightColumn: [] },
      };
    });

    // Flat lookup: allotId -> trolleyId (for the DOM loop below)
    const allotToTrolley = {};
    [...smuDetails, ...halfDetails, ...fullDetails].forEach((detail) => {
      allotToTrolley[detail.data._id] = detail.id;
    });

    // Collect filled slot data from DOM
    const ele = document.querySelectorAll('[id^="quantity"]');
    for (let i = 0; i < ele.length; i++) {
      let cart_id = ele[i].getAttribute("code");
      let row = ele[i].getAttribute("row");
      let subrow = ele[i].getAttribute("subrow");
      let cart_type = ele[i].getAttribute("carttype");
      let rack_size = ele[i].getAttribute("rack");
      let side = ele[i].getAttribute("side");

      let quantity;
      let attrVal;

      if (ele[i].value) {
        quantity = ele[i].value;
        const sele = document.getElementById(
          "select-" +
            cart_type +
            "-" +
            row +
            "-" +
            subrow +
            "-" +
            cart_id +
            "-" +
            side
        );
        if (sele && sele.getAttribute("attrValue")) {
          attrVal = sele.getAttribute("attrValue");
        }
        let cart_rack_value = "";
        const rack_ele = document.querySelectorAll('[code^="racks"]');
        for (let j = 0; j < rack_ele.length; j++) {
          if (rack_ele[j].getAttribute("id") === cart_id) {
            cart_rack_value = rack_ele[j].value;
            break;
          }
        }

        const s2Ele = document.getElementById(getSectorInputId('sectorS2', cart_type, row, subrow, cart_id, side));
        const s3Ele = document.getElementById(getSectorInputId('sectorS3', cart_type, row, subrow, cart_id, side));
        const multiEle = document.getElementById(getSectorInputId('sectorMulti', cart_type, row, subrow, cart_id, side));

        const cart = {
          itemId: attrVal,
          quantity: Number(quantity),
          singleSectorQty: Number(quantity),
          twoSectorQty: s2Ele?.value ? Number(s2Ele.value) : Number(quantity),
          tripleSectorQty: s3Ele?.value ? Number(s3Ele.value) : Number(quantity),
          multiSectorQty: multiEle?.value ? Number(multiEle.value) : Number(quantity),
          row: Number(row),
          subRow: Number(subrow),
          rackSize: rack_size,
          drawerName: "Drawer " + rack_size,
          rackType: cart_rack_value || 'drawer',
        };

        const tId = allotToTrolley[cart_id];
        const allot = tId ? trolleyPayloadMap[tId]?.allots[cart_id] : null;
        if (allot) {
          side === "left"
            ? allot.items.leftColumn.push(cart)
            : allot.items.rightColumn.push(cart);
        }
      }
    }

    // Only PUT trolleys that have at least one filled slot
    const activeGalleyId = galleyTabs._id || galleyId;
    const trolleyEntries = Object.entries(trolleyPayloadMap).filter(
      ([, data]) => Object.values(data.allots).some(
        (a) => a.items.leftColumn.length > 0 || a.items.rightColumn.length > 0
      )
    );

    if (trolleyEntries.length === 0) {
      setStatus({ error: 'No items entered — nothing to save.' });
      return;
    }

    try {
      setIsloading(true);
      const results = await Promise.all(
        trolleyEntries.map(([tId, data]) =>
          DFPAPIEndpointGalley.put(
            `galley/aircraftTypes/${aircraftId}/galleys/${activeGalleyId}/bayAreas/${data.bayAreaId}/trolleys/${tId}`,
            { cartQuantityAllots: Object.values(data.allots) }
          )
        )
      );

      // New endpoint returns { success: 1, data: { cartQuantityAllots: [...] } }
      const allOk = results.every((r) => r.success === 1 && r.data?.cartQuantityAllots);
      if (allOk) {
        setGalleyDetails([]);
        setIsloading(false);
        refreshTrolleyData();
        setStatus({ success: 'Trolley loading plan saved successfully.' });
        setSavedTab((current) => [
          ...current,
          { name: galleyTabs.name || '', value: true },
        ]);
      } else {
        setIsloading(false);
        setStatus({ error: 'One or more trolleys failed to save. Please retry.' });
      }
    } catch (error) {
      const errData = JSON.parse(error.message);
      setIsloading(false);
      setStatus({ error: errData.data?.message || errData.message || 'Something went wrong! Please try again.' });
    }
  };
  const downloadTroleyPlan = async () => {
    const path = DFPAPIEndpointGalley.getFullPath(
      "galley/trolley/loading/plan/download"
    );
    let headers = DFPAPIEndpointGalley.getHeaders();
    headers = headers.headers;
    try {
      const res = await fetch(path, {
        method: "POST",
        body: JSON.stringify({ aircraftTypeId: aircraftId, rackType: '' }),
        headers: headers,
      });
      const file = await res.blob();
      saveAs(file, `galary-plan.xlsx`);
    } catch (error) {

    }
  };


  const onClickTrolley = (e) => {
    setClickTrolley(e);
  };

  const stateLoop = (smu, half, full, stowage) => {
    smu?.map((ele, index) => {
      setSmuRowDetails((_) => {
        return { ..._, ["smu" + index]: row12 };
      });
      ele.data?.items.leftColumn?.forEach((it) => {
        if (it?.subRow > 0) {
          setSmuRowDetails((_) => {
            return {
              ..._,
              ["smu" + index]: {
                ..._["smu" + index],
                ["row" + it?.row]: it?.subRow,
              },
            };
          });
        }
      });
      return 0;
    });

    half?.map((ele, index) => {
      setHalfRowDetails((_) => {
        return { ..._, ["half" + index]: row28 };
      });
      ele.data?.items.leftColumn?.forEach((it) => {
        if (it?.subRow > 0) {
          setHalfRowDetails((_) => {
            return {
              ..._,
              ["half" + index]: {
                ..._["half" + index],
                ["row" + it?.row]: it?.subRow,
              },
            };
          });
        }
      });
      return 0;
    });

    full?.map((ele, index) => {
      setFullRowDetails((_) => {
        return { ..._, ["full" + index]: row28 };
      });
      setFullRowDetailsFront((_) => {
        return { ..._, ["fullfront" + index]: row28 };
      });

      ele.data?.items.leftColumn?.forEach((it) => {
        if (it?.subRow > 0) {
          setFullRowDetails((_) => {
            return {
              ..._,
              ["full" + index]: {
                ..._["full" + index],
                ["row" + it?.row]: it?.subRow,
              },
            };
          });
        }
      });
      ele.data?.items.rightColumn?.forEach((it) => {
        if (it?.subRow > 0) {
          setFullRowDetailsFront((_) => {
            return {
              ..._,
              ["fullfront" + index]: {
                ..._["fullfront" + index],
                ["row" + it?.row]: it?.subRow,
              },
            };
          });
        }
      });
      return 0;
    });
  };

  const trolleyRow = (
    type,
    index,
    row,
    num,
    code,
    finalsave,
    finalsave_right,
    rack_type
  ) => {

    if (type === "half") {
      return (
        <>
          <tr id={code + `-half-` + index}>
            {renderSectorInputs(index, 0, code, type, index, finalsave, "left")}
            <td className="no-padding">
              {trolleySearch(index, 0, code, type, finalsave, row, "left")}
            </td>
            <td rowSpan={halfRowDetails[row]?.[num] + 1}>{rack_type === 'drawer' ? "Drawer" : ""} {rack_type === 'drawer' ? index : index*0.5}</td>
            <td style={{width:"10%"}}>
              <div
                onClick={() =>
                  setHalfRowDetails((_) => {
                    return {
                      ..._,
                      [row]: {
                        ..._[row],
                        [num]: halfRowDetails[row]?.[num] + 1,
                      },
                    };
                  })
                }
              >
              {createTrolleyPlan?  <img src={plus} className="trolley-plus" alt="" />:null}
              </div>
            </td>
          </tr>
          {[...Array(halfRowDetails[row]?.[num])].map((elementInArray, ind) => {
            return (
              <tr>
                {renderSectorInputs(
                  index,
                  ind + 1,
                  code,
                  type,
                  index,
                  finalsave,
                  "left"
                )}
                <td className="no-padding">
                  {trolleySearch(
                    index,
                    ind + 1,
                    code,
                    type,
                    finalsave,
                    row,
                    "left"
                  )}
                </td>
                <td style={{width:"10%"}}>
                  <div
                    onClick={() =>
                      setHalfRowDetails((_) => {
                        return {
                          ..._,
                          [row]: {
                            ..._[row],
                            [num]: halfRowDetails[row]?.[num] - 1,
                          },
                        };
                      })
                    }
                  >
                  {deleteTrolleyPlan?  <img src={minus} className="trolley-plus" alt="" />:null}
                  </div>
                </td>
              </tr>
            );
          })}
        </>
      );
    } else if (type === "full") {
      return (
        <>
          <tr id={code + `-full-left-` + index}>
            {renderSectorInputs(index, 0, code, type, index, finalsave, "left")}
            <td className="no-padding">
              {trolleySearch(index, 0, code, type, finalsave, row, "left")}
            </td>
            <td className="no-wrap" rowSpan={fullRowDetails[row]?.[num] + 1}>
            {rack_type === 'drawer' ? "Drawer" : ""} {rack_type === 'drawer' ? index : index*0.5}
            </td>
            <td style={{width:"10%"}}>
              <div
                onClick={() =>
                  setFullRowDetails((_) => {
                    return {
                      ..._,
                      [row]: {
                        ..._[row],
                        [num]: fullRowDetails[row]?.[num] + 1,
                      },
                    };
                  })
                }
              >
                <img src={plus} className="trolley-plus" alt="" />
              </div>
            </td>
          </tr>
          {[...Array(fullRowDetails[row]?.[num])].map((elementInArray, ind) => {
            return (
              <tr>
                {renderSectorInputs(
                  index,
                  ind + 1,
                  code,
                  type,
                  index,
                  finalsave,
                  "left"
                )}
                <td className="no-padding">
                  {trolleySearch(
                    index,
                    ind + 1,
                    code,
                    type,
                    finalsave,
                    row,
                    "left"
                  )}
                </td>
                <td style={{width:"10%"}}>
                  <div
                    onClick={() =>
                      setFullRowDetails((_) => {
                        return {
                          ..._,
                          [row]: {
                            ..._[row],
                            [num]: fullRowDetails[row]?.[num] - 1,
                          },
                        };
                      })
                    }
                  >
                    <img src={minus} className="trolley-plus" alt="" />
                  </div>
                </td>
              </tr>
            );
          })}
        </>
      );
    } else if (type === "fullfront") {
      return (
        <>
          <tr id={code + `-full-right-` + index}>
            {renderSectorInputs(
              index,
              0,
              code,
              type,
              index,
              finalsave_right,
              "right"
            )}
            <td className="no-padding">
              {trolleySearch(
                index,
                0,
                code,
                type,
                finalsave_right,
                row,
                "right"
              )}
            </td>
            <td
              className="no-wrap"
              rowSpan={fullRowDetailsFront[row]?.[num] + 1}
            >
              {rack_type === 'drawer' ? "Drawer" : ""} {rack_type === 'drawer' ? index : index*0.5}
            </td>
            <td style={{width:"10%"}}>
              <div
                onClick={() =>
                  setFullRowDetailsFront((_) => {
                    return {
                      ..._,
                      [row]: {
                        ..._[row],
                        [num]: fullRowDetailsFront[row]?.[num] + 1,
                      },
                    };
                  })
                }
              >
                <img src={plus} className="trolley-plus" alt="" />
              </div>
            </td>
          </tr>
          {[...Array(fullRowDetailsFront[row]?.[num])].map(
            (elementInArray, ind) => {
              return (
                <tr>
                  {renderSectorInputs(
                    index,
                    ind + 1,
                    code,
                    type,
                    index,
                    finalsave_right,
                    "right"
                  )}
                  <td className="no-padding">
                    {trolleySearch(
                      index,
                      ind + 1,
                      code,
                      type,
                      finalsave_right,
                      row,
                      "right"
                    )}
                  </td>
                  <td style={{width:"10%"}}>
                    <div
                      onClick={() =>
                        setFullRowDetailsFront((_) => {
                          return {
                            ..._,
                            [row]: {
                              ..._[row],
                              [num]: fullRowDetailsFront[row]?.[num] - 1,
                            },
                          };
                        })
                      }
                    >
                      <img src={minus} className="trolley-plus" alt="" />
                    </div>
                  </td>
                </tr>
              );
            }
          )}
        </>
      );
    } else {
      return (
        <>
          <tr id={code + `-smu-` + index} style={index === 1 ? { height: "100px" } : {}}>
            {renderSectorInputs(index, 0, code, type, index, finalsave, "left")}
            <td className="no-padding">
              {trolleySearch(index, 0, code, type, finalsave, row, "left")}
            </td>
            <td style={{width:"10%"}} rowSpan={smuRowDetails[row]?.[num] + 1}>Drawer</td>
            <td style={{width:"10%"}}>
              <div
                onClick={() =>
                  setSmuRowDetails((_) => {
                    return {
                      ..._,
                      [row]: {
                        ..._[row],
                        [num]: smuRowDetails[row]?.[num] + 1,
                      },
                    };
                  })
                }
              >
                <img src={plus} className="trolley-plus" alt="" />
              </div>
            </td>
          </tr>
          {[...Array(smuRowDetails[row]?.[num])].map((elementInArray, ind) => {
            return (
              <tr>
                {renderSectorInputs(
                  index,
                  ind + 1,
                  code,
                  type,
                  index,
                  finalsave,
                  "left"
                )}
                <td className="no-padding">
                  {trolleySearch(
                    index,
                    ind + 1,
                    code,
                    type,
                    finalsave,
                    row,
                    "left"
                  )}
                </td>
                <td>
                  <div
                    onClick={() =>
                      setSmuRowDetails((_) => {
                        return {
                          ..._,
                          [row]: {
                            ..._[row],
                            [num]: smuRowDetails[row]?.[num] - 1,
                          },
                        };
                      })
                    }
                  >
                    <img src={minus} className="trolley-plus" alt="" />
                  </div>
                </td>
              </tr>
            );
          })}
        </>
      );
    }
  };

  const renderSectorInputs = (
    index,
    subIndex,
    code,
    type,
    rack,
    finalsave,
    side
  ) => {
    let defvalue, defS2, defS3, defMulti;
    finalsave?.map((em) => {
      if (em.cartid === code && em.row === index && em.subRow === subIndex) {
        defvalue = em.quantity ?? em.singleSectorQty;
        defS2 = em.twoSectorQty;
        defS3 = em.tripleSectorQty;
        defMulti = em.multiSectorQty;
      }
      return 0;
    });
    return (
      <>
        <td className="no-padding">
          <input
            key={`quantity-` + type + "-" + index + "-" + subIndex + "-" + code}
            id={`quantity` + code}
            defaultValue={defvalue}
            side={side}
            row={index}
            subrow={subIndex}
            carttype={type}
            disabled={!editTrolleyPlan}
            code={code}
            rack={rack}
            type="number"
            min="0"
            className="edit-input trollyQtyInp"
            name="quantity"
            attribute="shortName"
            onChange={(e) => onBaseQuantityChange(e, type, index, subIndex, code, side)}
          />
        </td>
        <td className="no-padding">
          <input
            id={getSectorInputId('sectorS2', type, index, subIndex, code, side)}
            defaultValue={defS2}
            disabled={!editTrolleyPlan}
            type="number"
            min="0"
            className="edit-input trollyQtyInp"
            name="twoSectorQty"
          />
        </td>
        <td className="no-padding">
          <input
            id={getSectorInputId('sectorS3', type, index, subIndex, code, side)}
            defaultValue={defS3}
            disabled={!editTrolleyPlan}
            type="number"
            min="0"
            className="edit-input trollyQtyInp"
            name="tripleSectorQty"
          />
        </td>
        <td className="no-padding">
          <input
            id={getSectorInputId('sectorMulti', type, index, subIndex, code, side)}
            defaultValue={defMulti}
            disabled={!editTrolleyPlan}
            type="number"
            min="0"
            className="edit-input trollyQtyInp"
            name="multiSectorQty"
          />
        </td>
      </>
    );
  };

  const renderSectorHeaders = () => {
    const factors = getSectorFactors();
    return (
      <>
        <th style={{ width: "8%" }}>S1 Qty.</th>
        <th style={{ width: "8%" }}>
          S2{" "}Qty.
          <span className="sector-factor-badge">
            {/* *{" "} */}
            <input
              type="number"
              step="0.1"
              className="edit-input_sect_limit"
              value={factors.s2}
              onChange={(e) => updateSectorFactor('s2', e.target.value)}
              style={{ width: "3rem" }}
            />
          </span>
        </th>
        <th style={{ width: "8%" }}>
          S3{" "}Qty.
          {/* <span className="sector-factor-badge">
            S1 *{" "}
            <input
              type="number"
              step="0.1"
              value={factors.s3}
              onChange={(e) => updateSectorFactor('s3', e.target.value)}
              style={{ width: "3rem" }}
            />
          </span> */}
        </th>
        <th style={{ width: "8%" }}>
          Multi{" "}Qty.
          {/* <span className="sector-factor-badge">
            S1 *{" "}
            <input
              type="number"
              step="0.1"
              value={factors.multi}
              onChange={(e) => updateSectorFactor('multi', e.target.value)}
              style={{ width: "3rem" }}
            />
          </span> */}
        </th>
      </>
    );
  };

  const trolleySearch = (index, subIndex, code, type, finalsave, row, side) => {
    let defvalue;
    let defcode;
    finalsave?.map((em) => {
      if (em.cartid === code && em.row === index && em.subRow === subIndex) {
        defcode = em.cartid;
        const resolved = resolveSlotItemLabel(em.itemId, enumerateItems, mealCategories);
        if (resolved) defvalue = resolved;
      }
      return 0;
    });
    setTimeout(() => {
      if (defcode === code && defvalue !== undefined) {
        const ele = document.getElementById(
          "select-" +
            type +
            "-" +
            index +
            "-" +
            subIndex +
            "-" +
            code +
            "-" +
            side
        );
        if (ele) {
          ele.setAttribute("attrValue", defvalue.value);
          ele.setAttribute("attrName", defvalue.label);
        }
      }
    }, 800);
    clearTimeout();

    return (
      <>
        <Select
          key={
            "select-" +
            type +
            "-" +
            index +
            "-" +
            subIndex +
            "-" +
            code +
            "-" +
            side +
            (defvalue ? "-" + defvalue.value : "")
          }
          defaultValue={defvalue}
          options={toSlotPickerOptions(enumerateItems, mealCategories)}
          formatOptionLabel={formatSlotOptionLabel}
          styles={customSelSearch(themedColor)}
          isSearchable
          placeholder="Select Item"
          id={
            "select-" +
            type +
            "-" +
            index +
            "-" +
            subIndex +
            "-" +
            code +
            "-" +
            side
          }
          onChange={(val) =>
            onChangeHandler(val, type, index, subIndex, code, side)
          }
          menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
          menuPosition="fixed"
        />
      </>
    );
  };

  return (
    <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark" >
      {
        <>
          <div className="row-trolley">
           {!hideGalleyNav && (
           <div className="column-trolley" style={{ width: "20%", maxHeight: "100vh", overflowY: "auto" ,padding:'16px'}}>
              <>
                <label className="req mb-2 margBottom10">
                  Aircraft Model :
                  <br />
                  <div className="margTop8 margBottom10"  title={airCraftLoadingSel?.model || ''}>
                      {(aircraftOptions?.model?.length > 0 && airCraftLoadingSel?.model?.length > 0) ? (
                      <button className="saleType-div">
                        <CustomSelect
                        options={aircraftOptions?.model}
                        placeHolder="Select Aircraft Variant"
                        controlStyle={{ border: "1px solid rgba(40,80,140,0.45)", borderRadius: 7 }}
                        width={'13rem'}
                        isDisabled={true}
                        value={aircraftOptions?.model?.filter(option=> option.label === airCraftLoadingSel.model)}
                        onChange={onAircraftChange}
                        />
                      </button>
                    ) : (<></>)}
                  </div>
                </label>
              </>
              <div className="flexRow width100 margBot10">
                <div className="alignItemsCenter">
                  <div className="bloc-tabs-trolley" style={{gap:'0px'}}>
                    {airCraftLoadingSel?.model?.length>0&&galleyArr.length ? <> {getGalleyTabs()}
                     </> : <></>}
                  </div>


                  <div className="column-trolley" style={{ width: "20%" }}>
                    {airCraftLoadingSel?.model?.length>0&&showGalley && (
                      <div className="row tab-pane">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 mt-3">
                          <div className="nav-menu-items">
                            <div className="trolley-detail">
                              <button
                                className="upload mt-3 text-center"
                                style={{
                                  maxWidth: "200px",
                                  marginLeft: "40px",
                                  marginRight: "8px",
                                }}
                              >
                                <span>
                                  <u>Galley Details</u>
                                </span>
                              </button>
                              <span
                                className="upload dropdownStyle1-TextMedium"
                                onClick={downloadTroleyPlan}
                              >
                                <img
                                  className="mt-2 icon-size"
                                  alt="uploadItem"
                                  src={downloadMasterIcon}
                                />
                              </span>
                              <ul style={{ marginTop: "0" }}>
                                <div
                                  className={`trolley-bullet ${
                                    clickTrolley === "smu" && "tb-tabs"
                                  }`}
                                  onClick={(e) => onClickTrolley("smu")}
                                >
                                  {cartsStatus?.smu} SMU
                                </div>
                                <div
                                  className={`trolley-bullet ${
                                    clickTrolley === "half" && "tb-tabs"
                                  }`}
                                  onClick={(e) => onClickTrolley("half")}
                                >
                                  {cartsStatus?.halfCart} Half Carts
                                </div>
                                <div
                                  className={`trolley-bullet ${
                                    clickTrolley === "full" && "tb-tabs"
                                  }`}
                                  onClick={(e) => onClickTrolley("full")}
                                >
                                  {cartsStatus?.fullCart} Full Carts
                                </div>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <button
                          style={{
                            width: "170px",
                            maxWidth: "200px",
                            marginLeft: "16px",
                            marginTop: "23px",
                            position: "sticky",
                            bottom: "1rem",
                            zIndex: 10,
                          }}
                          className={loading?`done-button subheading-text-medium-title fontLight button_inrt`:`done-button subheading-text-medium-title fontLight`}
                          onClick={saveTrolleyPlan}
                        >
                          Save
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
           )}
            <div className="column-trolley" style={{ width: hideGalleyNav ? "100%" : "80%" }}>
              <div className="container-fluid trolley-container-lg">
                <div className="container-fluid">
                  <div className="dialog__footer flexRow justifyContentSpaceBetween flexWrap margRight30">
                    <div></div>
                  </div>
                </div>
              <ToastContainer/>
                <div
                  style={{ position: "relative", marginBottom: hideGalleyNav ? "24px" : "400px" }}
                  id="galleyDesign1"
                >
                  {airCraftLoadingSel?.model?.length>0&&showGalley && viewDetailsTrolleyPlan && (
                    <div className="container-fluid first">
                      <div
                        style={{ position: "relative", marginBottom: hideGalleyNav ? "24px" : "400px" }}
                        id="galleyDesign"
                      >
                        <div className="container-fluid first">
                          <div className="row tab-pane">
                            {smuDetails.map((elementInArray, indexcart) => {
                              let typeid = smuDetails.id;
                              let code = elementInArray.data._id;
                              let track = indexcart;
                              let hidden =
                                clickTrolley === "smu" ? false : true;

                              let filterSave = [];
                              elementInArray.data.items?.leftColumn.map(
                                (saveitem, saveindex) => {
                                  const newArray = {
                                    ...saveitem,
                                    cartid: code,
                                    typeid: typeid,
                                    track: track,
                                  };
                                  filterSave.push(newArray);
                                  return 0;
                                }
                              );

                              return (
                                <div
                                  hidden={hidden}
                                  className=""
                                  style={
                                    indexcart === 0
                                      ? { marginTop: "10px" }
                                      : { marginTop: "50px" }
                                  }
                                >
                                  <label className="req mb-2">
                                    Standard Container: {elementInArray.code}{" "}
                                  </label>
                                  <div className="dialog__container_item input-container"></div>
                                  <table
                                    id={
                                      `trolley-table-smu` + elementInArray.code
                                    }
                                  >
                                    <tr className="header-white">
                                      {renderSectorHeaders()}
                                      <th style={{ width: "22%" }}>
                                        Item Name
                                      </th>
                                      <th style={{ width: "10%" }}></th>
                                      <th style={{ width: "12%" }}>Add</th>
                                    </tr>
                                    {[...Array(staticCountSmu)].map(
                                      (element, index) => {
                                        index = index + 1;
                                        let attr = "row" + index;
                                        let row = "smu" + track;
                                        let type = "smu";
                                        return trolleyRow(
                                          type,
                                          index,
                                          row,
                                          attr,
                                          code,
                                          filterSave
                                        );
                                      }
                                    )}
                                  </table>
                                  {/* <div className="mt-3">
                                    Apply this Design :<br />
                                    <input type="checkbox" className="mt-3" />
                                    <span className="mb-2">
                                      {" "}
                                      &nbsp;&nbsp;Aircraft
                                    </span>
                                    <input
                                      type="checkbox"
                                      className="mt-3"
                                      style={{ marginLeft: "2.5rem" }}
                                    />
                                    <span className="mb-2">
                                      {" "}
                                      &nbsp;&nbsp;Galley
                                    </span>
                                  </div> */}
                                </div>
                              );
                            })}
                            {halfDetails.map((elementInArray, index) => {
                              let rackInd = 0;
                              rackLoadingSelHalf.find((e,i) => {
                                  if(e.val[0] === elementInArray.data._id){
                                    rackInd = i;
                                  }
                                  return null
                              })
                              // Locked to drawer — selector is hidden
                              let rackType = 'drawer';
                              let finalRackVal = 7;

                              let typeid = halfDetails.id;
                              let code = elementInArray.data._id;
                              let track = index;
                              let hidden = clickTrolley === "half" ? false : true;

                              let filterSave = [];
                              elementInArray.data.items?.leftColumn.map(
                                (saveitem, saveindex) => {
                                  const newArray = {
                                    ...saveitem,
                                    cartid: code,
                                    typeid: typeid,
                                    track: track,
                                  };
                                  filterSave.push(newArray);
                                  return 0;
                                }
                              );

                              return (
                                <div
                                  hidden={hidden}
                                  style={
                                    index === 0
                                      ? { marginTop: "10px" }
                                      : { marginTop: "50px" }
                                  }
                                >
                                  <label className="req mb-2">
                                    Half Size Cart: {elementInArray.code} - {rackType}
                                  </label>
                                  <div className="floatRight mb-3" style={{ display: 'none' }}>
                                    {aircraftOptions?.model?.length ? (
                                      <button className="margRight30">
                                          <select  code="racks" name="racksHalf"  value={rackType} id={code} className="padding0 select-item-rack mb-2" onChange={onRackChange}>
                                            <option value="slot">Slot</option>
                                            <option value="drawer">Drawer</option>
                                          </select>
                                      </button>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                  <div className="dialog__container_item input-container"></div>
                                  <table
                                    id={
                                      `trolley-table-half` + elementInArray.code
                                    }
                                  >
                                    <tr className="header-white">
                                      {renderSectorHeaders()}
                                      <th style={{ width: "22%" }}>
                                        Item Name
                                      </th>
                                      <th style={{ width: "10%" }}></th>
                                      <th style={{ width: "12%" }}>Add</th>
                                    </tr>
                                    {
                                        [...Array(finalRackVal)].map(
                                          (element, index) => {
                                            index = index + 1;
                                            let attr = "row" + index;
                                            let row = "half" + track;
                                            let type = "half";

                                            return trolleyRow(
                                              type,
                                              index,
                                              row,
                                              attr,
                                              code,
                                              filterSave,
                                              null,
                                              rackType
                                            );
                                          }
                                        )
                                    }
                                  </table>
                                  <img
                                    className="Images"
                                    src={trolley}
                                    alt=""
                                    style={{ width: "34rem" }}
                                  />
                                  {/* <div className="mt-3">
                                    Apply this Design :<br />
                                    <input type="checkbox" className="mt-3" />
                                    <span className="mb-2">
                                      {" "}
                                      &nbsp;&nbsp;Aircraft
                                    </span>
                                    <input
                                      type="checkbox"
                                      className="mt-3"
                                      style={{ marginLeft: "2.5rem" }}
                                    />
                                    <span className="mb-2">
                                      {" "}
                                      &nbsp;&nbsp;Galley
                                    </span>
                                  </div> */}
                                </div>
                              );
                            })}

                            {fullDetails.map((elementInArray, index) => {
                               const matchedFullRack = rackLoadingSelFull.find((e) => e.val[0] === elementInArray.data._id);
                               // Locked to drawer — selector is hidden
                               let rackType = 'drawer';
                               let finalRackVal = 7;

                              let typeid = fullDetails.id;
                              let code = elementInArray.data._id;
                              let track = index;
                              let hidden =
                                clickTrolley === "full" ? false : true;

                              let filterSave = [];
                              elementInArray.data.items?.leftColumn.map(
                                (saveitem, saveindex) => {
                                  const newArray = {
                                    ...saveitem,
                                    cartid: code,
                                    typeid: typeid,
                                    track: track,
                                  };
                                  filterSave.push(newArray);
                                  return 0;
                                }
                              );

                              let filterSave2 = [];
                              elementInArray.data.items?.rightColumn.map(
                                (saveitem, saveindex) => {
                                  const newArray2 = {
                                    ...saveitem,
                                    cartid: code,
                                    typeid: typeid,
                                    track: track,
                                  };
                                  filterSave2.push(newArray2);
                                  return 0;
                                }
                              );

                              return (
                                <div>
                                  {hideGalleyNav && !hidden ? (
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        position: 'relative',
                                        width: '100%',
                                        marginTop: index === 0 ? '10px' : '50px',
                                        marginBottom: '12px',
                                        minHeight: 40,
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: 'flex',
                                          gap: 4,
                                          border: '1px solid rgba(40,80,140,0.3)',
                                          borderRadius: 6,
                                          padding: 4,
                                        }}
                                      >
                                        {['back', 'front'].map((side) => (
                                          <button
                                            key={side}
                                            type="button"
                                            onClick={() => setFullCartSide(side)}
                                            style={{
                                              padding: '8px 16px',
                                              borderRadius: 4,
                                              border: 'none',
                                              background: fullCartSide === side ? 'rgba(76,195,230,0.2)' : 'transparent',
                                              color: fullCartSide === side ? '#4cc3e6' : '#8aaacf',
                                              fontSize: 13,
                                              fontWeight: fullCartSide === side ? 600 : 400,
                                              cursor: 'pointer',
                                            }}
                                          >
                                            {elementInArray.code} - {side === 'back' ? 'Back' : 'Front'}
                                          </button>
                                        ))}
                                      </div>
                                      {aircraftOptions?.model?.length ? (
                                        <select
                                          code="racks"
                                          name="racksFull"
                                          value={rackType || 'drawer'}
                                          id={code}
                                          className="select-item-rack"
                                          onChange={onRackChange}
                                          style={{
                                            display: 'none',
                                            position: 'absolute',
                                            right: 0,
                                            top: 0,
                                            minWidth: '7.5rem',
                                            width: '7.5rem',
                                            maxWidth: '8.5rem',
                                            height: '40px',
                                            padding: '0 8px',
                                            color: '#d6eaf8',
                                            backgroundColor: '#111d35',
                                            border: '1px solid rgba(40,80,140,0.45)',
                                            borderRadius: 6,
                                          }}
                                        >
                                          <option value="slot">Slot</option>
                                          <option value="drawer">Drawer</option>
                                        </select>
                                      ) : null}
                                    </div>
                                  ) : null}
                                  <div
                                    className="full-row"
                                    hidden={hidden}
                                    style={
                                      index === 0
                                        ? { marginTop: hideGalleyNav ? "0px" : "10px", display: "flex" }
                                        : { marginTop: hideGalleyNav ? "0px" : "50px", display: "flex" }
                                    }
                                  >
                                    <div
                                      className="full-column"
                                      style={{
                                        width: hideGalleyNav ? "100%" : "50%",
                                        float: "left",
                                        marginTop:"0.6rem",
                                        display: hideGalleyNav && fullCartSide !== 'back' ? 'none' : undefined,
                                      }}
                                    >
                                      {hideGalleyNav ? null : (
                                      <label className="req mb-2">
                                        Full Size Cart: {elementInArray.code} -
                                        Back
                                      </label>
                                      )}
                                      <div className="dialog__container_item input-container"></div>
                                      <table
                                        id={`trolley-table-full-back` + index}
                                      >
                                        <tr className="header-white">
                                          {renderSectorHeaders()}
                                          <th style={{ width: "38%" }}>
                                            Item Name
                                          </th>
                                          <th style={{ width: "10%" }}></th>
                                          <th style={{ width: "12%" }}>Add</th>
                                        </tr>
                                        {[...Array(finalRackVal)].map(
                                          (element, index) => {
                                            index = index + 1;
                                            let attr = "row" + index;
                                            let row = "full" + track;
                                            let type = "full";

                                            return trolleyRow(
                                              type,
                                              index,
                                              row,
                                              attr,
                                              code,
                                              filterSave,
                                              null,
                                              rackType
                                            );
                                          }
                                        )}
                                      </table>
                                    </div>

                                    <div
                                      className="full-column"
                                      style={{
                                        width: hideGalleyNav ? "100%" : "50%",
                                        marginLeft: hideGalleyNav ? "0" : "2rem",
                                        display: hideGalleyNav && fullCartSide !== 'front' ? 'none' : undefined,
                                      }}
                                    >
                                      {hideGalleyNav ? null : (
                                      <>
                                      <label className="req mb-2">
                                        Full Size Cart: {elementInArray.code} -
                                        Front
                                      </label>
                                      <div className="floatRight mb-2">
                                        {aircraftOptions?.model?.length ? (
                                        <button className="">
                                          <select code="racks" name="racksFull"  value={rackType} id={code} className="select-item-rack" onChange={onRackChange}>
                                            <option value="slot">Slot</option>
                                            <option value="drawer">Drawer</option>
                                          </select>
                                        </button>
                                      ) : (
                                      <></>
                                    )}
                                  </div>
                                      </>
                                      )}
                                      <div className="dialog__container_item input-container"></div>
                                      <table
                                        id={`trolley-table-full-front` + index}
                                      >
                                        <tr className="header-white">
                                          {renderSectorHeaders()}
                                          <th style={{ width: "38%" }}>
                                            Item Name
                                          </th>
                                          <th style={{ width: "10%" }}></th>
                                          <th style={{ width: "12%" }}>Add</th>
                                        </tr>
                                        {[...Array(finalRackVal)].map(
                                          (element, index) => {
                                            index = index + 1;
                                            let attr = "row" + index;
                                            let row = "fullfront" + track;
                                            let type = "fullfront";

                                            return trolleyRow(
                                              type,
                                              index,
                                              row,
                                              attr,
                                              code,
                                              filterSave,
                                              filterSave2,
                                              rackType
                                            );
                                          }
                                        )}
                                      </table>
                                    </div>
                                  </div>
                                  {clickTrolley === "full" && !hideGalleyNav ? (
                                    <>
                                      <img
                                        className="Images"
                                        src={trolley}
                                        alt=""
                                        style={{ width: "34rem" }}
                                      />
                                      {/* <div className="mt-3">
                                        Apply this Design :<br />
                                        <input
                                          type="checkbox"
                                          className="mt-3"
                                        />
                                        <span className="mb-2">
                                          {" "}
                                          &nbsp;&nbsp;Aircraft
                                        </span>
                                        <input
                                          type="checkbox"
                                          className="mt-3"
                                          style={{ marginLeft: "2.5rem" }}
                                        />
                                        <span className="mb-2">
                                          {" "}
                                          &nbsp;&nbsp;Galley
                                        </span>
                                      </div> */}
                                    </>
                                  ) : null}
                                </div>
                              );
                            })}
                            {(clickTrolley === "full" &&
                              cartsStatus.fullCart === 0) ||
                            (clickTrolley === "half" &&
                              cartsStatus.halfCart === 0) ||
                            (clickTrolley === "smu" && cartsStatus.smu === 0) ||
                            (clickTrolley === "stowage" &&
                              cartsStatus.stowage === 0) ? (
                              <div
                                style={{
                                  textAlign: "center",
                                  marginTop: "20%",
                                }}
                              >
                                No Data Available
                              </div>
                            ) : null}
                            {hideGalleyNav ? (
                              <div style={{ display: 'flex', justifyContent: 'center', width: '100%', padding: '24px 0 32px', clear: 'both' }}>
                                <button
                                  style={{
                                    width: "170px",
                                    maxWidth: "200px",
                                  }}
                                  className={loading?`done-button subheading-text-medium-title fontLight button_inrt`:`done-button subheading-text-medium-title fontLight`}
                                  onClick={saveTrolleyPlan}
                                >
                                  Save
                                </button>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <button 
    className="modal-close"
    onClick={onClose}
    style={{ 
      position: 'absolute',
      top: '12px',
      right: '12px',
      fontSize: '28px',
      cursor: 'pointer',
      background: 'none',
      border: 'none',
      zIndex: 1001
    }}
    >
    ×
    </button>
        </>
      }
      {!ready && (
        <div className="overlay_hide sub"></div>
      )}
    </div>
  );
};
